export default __webpack_public_path__ + "static/media/12.1b6279f7.png";